import React, {useEffect} from 'react';
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import ClonePlateFormat from "./ClonePlateFormat.jsx";
import CloneModalPassageCard from "./CloneModalPassageCard.jsx";
import {FaAngleLeft} from "react-icons/fa6";
import {FaAngleRight, FaListOl, FaPlus, FaPrint} from "react-icons/fa";
import clonesService from "../../../../services/web/clones-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import {toast} from "react-toastify";
const API_URL = import.meta.env.VITE_API_URL;
const BASENAME = import.meta.env.BASE_URL;

const CloneModal = ({show, setShow, rowSelected, setRowSelected, tableRef, filters, refetch}) => {
    const tableApi = tableRef.current?.api;

    const closeModal = () => setShow(false);

    const nextOrPrevious = (target) => {
        let currentIndex;
        const allRows = [];

        tableApi.forEachNodeAfterFilterAndSort((node, index) => {
            allRows.push(node);

            if (node.data.id === rowSelected.id) currentIndex = index;
        });

        if (currentIndex === undefined) return;

        if (target === "previous" && currentIndex > 0) {
            setRowSelected(allRows[currentIndex - 1].data);
        } else if (target === "next" && currentIndex < allRows.length - 1) {
            setRowSelected(allRows[currentIndex + 1].data);
        }
    }

    const openOccurrences = () => {
        const formData = new FormData();
        formData.append("occurrences", rowSelected.occ_id)

        clonesService.openAssociated(formData)
            .then(() => {
                toast.success("A lista de ocorrências associadas será aberta no SentryView")
            })
            .catch(error => {
                console.error(error);
                toast.error('Ocorreu um erro ao abrir a ocorrência no SentryView.');
            });
    }

    const createOccurrence = () => {
        clonesService.createOccurrence({plate: rowSelected?.plate.rawValue})
            .then(() => {
                toast.success("O cadastro de ocorrência será aberto no SentryView");
            })
            .catch(error => {
                console.error(error);
                toast.error('Ocorreu um erro ao abrir o cadastro no SentryView.')
            });
    }

    const openPassage = () => {
        const initialDate = filters.dt_ini ? projectUtils.formatDate(filters.dt_ini, "DD/MM/YYYY hh:mm:ss") : null;
        const finalDate = filters.dt_end ? projectUtils.formatDate(filters.dt_end, "DD/MM/YYYY hh:mm:ss") : null;

        const formData = new FormData();
        formData.append('plate', rowSelected.plate.rawValue);
        formData.append('initialDate', initialDate);
        formData.append('finalDate', finalDate);

        clonesService.openPassage(formData)
            .then(() => {
                toast.success(`A pesquisa para a placa ${rowSelected.plate.formattedValue} será aberta no SentryView.`);
            })
            .catch(error => {
                console.error(error);
                toast.error('Ocorreu um erro ao abrir a pesquisa no SentryView.');
            });
    }

    const sharedInstitutionsList = () => {
        if (rowSelected.info1 && rowSelected.info2) {
            window.open(`${BASENAME}shared-institutions?names=${rowSelected.info1.entityName},${rowSelected.info2.entityName}`, '_blank');
            return;
        }

        window.open(`${BASENAME}shared-institutions?cities=${rowSelected.citynamea},${rowSelected.citynameb}`, '_blank');
    }

    const  markAsVerified = () => {
        const formData = new FormData();
        formData.append('id', rowSelected.id);

        clonesService.markVerified(formData).then(({data}) => {
            setRowSelected(data);
            refetch();
        });
    }

    const openGoogleMaps = () => {
        const location1 = encodeURIComponent(rowSelected.info1.laneAddressFormatted);
        const location2 = encodeURIComponent(rowSelected.info2.laneAddressFormatted);

        window.open(`https://www.google.com/maps/dir/?api=1&origin=${location1}&destination=${location2}`, 'blank_');
    }

    return (
        <Modal id="modal-clone" open={show} setOpen={setShow} alignTop={true} title={
            <div className="flex justify-between items-center w-full">
                <img className="float-left"
                     src={API_URL + "/public/assets/img/sentry-logo-black.png"} alt="image"/>

                <p className={"text-2xl"}>Verificação de clone</p>

                <Button title="Imprimir" className="flex items-center gap-2 mr-2" onClick={() => window.open(`${BASENAME}reports/cloneInfo?id=${rowSelected?.id}`)}>
                    <FaPrint/>
                </Button>
            </div>
        }>
            <Modal.Body className="pt-2 pb-2">
                <div className="w-full flex flex-col items-center mb-2">
                    <div className="w-28.75">
                        <ClonePlateFormat value={rowSelected?.plate} />
                    </div>

                    <div className="text-sm font-light">
                        {rowSelected?.renavam || "Sem informações"}
                    </div>

                    <div className="text-sm italic font-light">
                        {
                            rowSelected?.verified ?
                                <>
                                    Verificado
                                    por <strong>{rowSelected?.login}</strong> em <strong>{rowSelected?.date_time_sign}</strong>
                                </> : "Verificação pendente"
                        }
                    </div>

                    <div className="text-xs font-light">
                        {rowSelected?.uuid}
                    </div>
                </div>

                <div className="grid grid-cols-12 mb-5 gap-4">
                    <div className="flex items-center col-span-1">
                        <Button className="nextOrPreviousBtn" onClick={() => nextOrPrevious("previous")}>
                            <FaAngleLeft/>
                        </Button>
                    </div>

                    <CloneModalPassageCard info={rowSelected?.info1} title={"Passagem 1"} attach={rowSelected?.attach1}/>

                    <CloneModalPassageCard info={rowSelected?.info2} title={"Passagem 2"} attach={rowSelected?.attach2}/>

                    <div className="flex items-center justify-end col-span-1">
                        <Button className="nextOrPreviousBtn" onClick={() => nextOrPrevious("next")}>
                            <FaAngleRight/>
                        </Button>
                    </div>
                </div>

                <div className="flex items-center justify-center gap-2">
                    {
                        rowSelected?.occ_id ?
                            <Button variant="primary" onClick={() => openOccurrences()}>
                                <FaListOl/> Visualizar ocorrência
                            </Button> :
                            <Button variant="primary" onClick={() => createOccurrence()}>
                                <FaPlus/> Criar ocorrência
                            </Button>
                    }
                    <Button variant="primary" onClick={() => sharedInstitutionsList()}>Contatos</Button>
                    <Button variant="primary" onClick={() => openPassage()}>
                        Pesquisar passagens
                    </Button>
                    {
                        !rowSelected?.verified &&
                        <Button variant="primary" onClick={() => markAsVerified()}>
                            Marcar como verificado
                        </Button>
                    }
                    {
                        rowSelected?.info1?.laneAddressFormatted && rowSelected?.info2?.laneAddressFormatted &&
                        <Button variant="primary" onClick={() => openGoogleMaps()}>
                            Exibir locais no mapa
                        </Button>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer className={"justify-center!"}>
                <div className="w-[75%] p-1 text-center bg-[#FBF0DA] text-yellow-800 border border-[#E9D2A3] rounded-md">
                    <h4 className="mb-1 text-lg font-semibold leading-tight">
                        Não entre em contato com o proprietário! Ele pode ser o dono do clone!
                    </h4>
                    <p className="mb-1 text-xs">
                        Entre em contato com as outras cidades em que este veículo circula para levantar mais
                        informações.
                    </p>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default CloneModal;